export enum BoardSteps {
  status = 'status',
  soil = 'soil',
  crop = 'crop',
  fertilization = 'fertilization',
  mineralization = 'mineralization',
}

export enum Metric {
  metric = 'Metric system',
  imperial = 'Imperial system',
}

export enum RoleNames {
  all = 'All',
  blueGreen = 'Blue&Green',
  blue = 'Blue',
  green = 'Green',
  blueLight = 'Lightblue',
  admin = 'superuser',
}
